@if(recommendations.length > 1){
<div ngbAccordion class="mb-4 mt-lg-5">
    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton><h6 class="align-middle mb-0" [ngClass]="{ 'placeholder': recommendations.length == 0 }">{{ 'si_pts_chrome_more_tips_header' | cmsText | async }}</h6></button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                @if (listLayout) {
                <!-- The top recommendation again, highlighted with its button, then the rest with round links -->
                <div class="tips-list">
                    @for (recommendation of recommendations; track recommendation) {
                    <app-tips-tile [recommendation]="recommendation" [variant]="$first ? 'highlight' : 'row'"></app-tips-tile>
                    }
                </div>
                } @else {
                <div class="row">
                    @for (recommendation of recommendations; track recommendation) {
                    @if (recommendation  && !$first){
                    <div class="col-12 col-sm-6 px-0 py-1">
                        <app-tips-tile [recommendation]="recommendation"></app-tips-tile>
                    </div>
                    }
                    }
                </div>
                }
            </div>
        </div>
    </div>
</div>
}
